export default "__VITE_ASSET__CcRqMyRA__"